import { WebhooksApiClient } from '@fourthwall/services/dist/WebhooksApiClient'
import { createMutationHook } from '@fourthwall/utils/dist/queries'

export const useDeleteWebhookConfigurationMutation = createMutationHook(
  WebhooksApiClient.deleteWebhookConfiguration,
  {
    mutationKey: ['deleteWebhookConfiguration'],
  },
)
